/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/15/22
 */

import {gql} from "urql";
import {Holiday, ListResponse} from "../../interfaces/Global";

export const HolidaysQuery = gql`
    query Holidays($countryCodes: [String!]!, $from: Date, $to: Date) {
        holidays(countryCodeIn: $countryCodes, endDateGt: $from, startDateLt: $to, limit: 1000) {
            total
            items {
                id
	            creationDate
                title
                countryCode
                city
                state
                startDate
                endDate
	            notes
	            properties
            }
        }
    }
`;

export interface HolidaysResponse {
	holidays: ListResponse<Holiday>
}

export interface HolidaysQueryVars {
	countryCodes: string[]
	from: Date
	to: Date
}